import React from "react";
import { Button } from "@shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@shared/components/ui/dialog";
import { useTranslation } from "react-i18next";
import { SelectUser } from "@features/users/SelectUser";
import { useUpdateUser } from "@features/users/useUsers";
import { toast } from "sonner";
import { UserCircle2, Edit3 } from "lucide-react";

export default function AssignCollector({ clientUser }) {
  const { t } = useTranslation();
  const { updateUser, isLoading } = useUpdateUser();
  const [open, setOpen] = React.useState(false);
  const [collectorId, setCollectorId] = React.useState(
    clientUser?.collector?._id || ""
  );

  React.useEffect(() => {
    setCollectorId(clientUser?.collector?._id || "");
  }, [clientUser]);

  const handleSave = () => {
    if (!clientUser) return;
    updateUser(
      { id: clientUser._id, values: { collector: collectorId } },
      {
        onSuccess: () => {
          toast.success(t("users.collectorAssigned"));
          setOpen(false);
        },
        onError: (error) => {
          toast.error(error?.response?.data?.message || t("messages.error"));
        },
      }
    );
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <Edit3 className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <UserCircle2 className="h-5 w-5" />
            {t("users.assignCollector")}
          </DialogTitle>
          <DialogDescription>
            {t("users.assignCollectorDescription")}
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <SelectUser
            role="collector"
            onSelectUser={(id) => setCollectorId(id)}
            user={collectorId}
            showAllOption={true}
          />
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => setOpen(false)}
            disabled={isLoading}
          >
            {t("main.cancel")}
          </Button>
          <Button onClick={handleSave} disabled={isLoading}>
            {isLoading ? t("main.saving") : t("main.save")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
